export { useAPIPostPutTechDetails } from './post-put-tech-details.hook';
export * from './post-put-tech-details.hook.types';
